export const clientDefinition: any = {
        requireInvoice: {
            id: 'requireInvoice',
            name: 'requireInvoice',
            value: false,
            label: '¿Requiere factura?',
        },
        isForeign: {
            id: 'isForeign',
            name: 'isForeign',
            value: false,
            label: '¿Es extranjero?',
        },
        country: {
            id: 'country',
            name: 'country',
            value: '141',
            label: 'País:',
            placeholder: 'Pais',
        },
        state: {
            id: 'state',
            name: 'state',
            value: '1',
            label: 'Estado',
            placeholder: 'Estado',
        },
        name: {
            id: 'name',
            name: 'name',
            value: '',
            label: 'Nombre o razón social:',
            placeholder: 'Nombre o razón social',
            validation: 'requiredIf:requireInvoice|isValidName',
            maxLength: 220,
        },
        useCfdi: {
            id: 'useCfdi',
            name: 'useCfdi',
            value: '',
            label: 'Uso del Cfdi:',
            placeholder: 'Uso del cfdi',
            validation: 'requiredIf:requireInvoice',
        },
        rfc: {
            id: 'rfc',
            name: 'rfc',
            value: '',
            label: 'Rfc:',
            placeholder: 'Rfc',
            maxLength: 13,
            validation: 'requiredIf:requireInvoice|minLength:12',
        },
        tin: {
            id: 'tin',
            name: 'tin',
            value: '',
            label: 'Número de identificación tributaria:',
            placeholder: 'Número de identificación tributaria',
            validation: 'requiredIf:isForeign',
        },
        email: {
            id: 'email',
            name: 'email',
            value: '',
            label: 'Email:',
            placeholder: 'Email',
            validation: 'required|email'
        },
        street: {
            id: 'street',
            name: 'street',
            value: '',
            placeholder: 'Calle',
            label: 'Calle:',
        },
        external: {
            id: 'external',
            name: 'external',
            value: '',
            label: 'Número exterior:',
            placeholder: 'Exterior',
        },
        interior: {
            id: 'interior',
            name: 'interior',
            value: '',
            label: 'Numero interior:',
            placeholder: 'Interior',
        },
        zip: {
            id: 'zip',
            name: 'zip',
            value: '',
            label: 'Codigo Postal:',
            placeholder: 'Codigo Postal',
            pattern: 'number',
            maxLength: 5,
            validation: 'required|minLength:5',
        },
        suburb: {
            id: 'suburb',
            name: 'suburb',
            value: '',
            label: 'Colonia:',
            placeholder: 'Colonia',
        },
        municipality: {
            id: 'municipality',
            name: 'municipality',
            value: '',
            label: 'Municipio:',
            placeholder: 'Municipio',
        },
        phone: {
            id: 'phone',
            name: 'phone',
            value: '',
            label: 'Teléfono:',
            placeholder: 'Teléfono',
            pattern: 'number',
            maxLength: 10,
            validation: 'minLength:10'
        },
        taxRegime: {
            id: 'taxRegime',
            name: 'taxRegime',
            value: '12',
            label: 'Régimen Fiscal:',
            placeholder: 'Régimen Fiscal',
        },
        descripcion_orden: {
            id: 'descripcion_orden',
            name: 'descripcion_orden',
            value: '',
            label: 'Nombre:',
            placeholder: 'Nombre',
            validation: 'required',
        },
    }